// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getPerformance } from "firebase/performance";
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getGenerativeModel, getVertexAI } from "firebase/vertexai-preview";
import { getRemoteConfig } from "firebase/remote-config";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBKFHahKlM8BufbktJwDYLob_aE2xm9ZeQ",
  authDomain: "divvi-portfolio-website.firebaseapp.com",
  databaseURL: "https://divvi-portfolio-website-default-rtdb.firebaseio.com",
  projectId: "divvi-portfolio-website",
  storageBucket: "divvi-portfolio-website.appspot.com",
  messagingSenderId: "519049312374",
  appId: "1:519049312374:web:5a54c198517db377df8757",
  measurementId: "G-RDPD8KQY2V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Remote Config and get a reference to the service
export const remoteConfig = getRemoteConfig(app);

// Initialize App Check with reCAPTCHA v3

// Enable below when doing local development and unable to access firebase services due to reCAPTCHA
// add the debug token generated by finding in firebase console to app check debug token list in firebase.
// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LdlhuAqAAAAAKu2OwDigCPRNScdFQQpA6UtXXOS"),
  isTokenAutoRefreshEnabled: true,
});

export const database = getDatabase(app);
const vertexAI = getVertexAI(app);

export const generativeModel = getGenerativeModel(vertexAI, {
  model: "gemini-2.0-flash",
  systemInstruction: "You are an AI Assitant designed to answer questions about education and certifications in general.",
});

// Initialize Performance Monitoring and Analytics only in browser environment
let perf = null;
let analytics = null;

if (typeof window !== 'undefined') {
  perf = getPerformance(app);
  analytics = getAnalytics(app);

  // Always enable analytics collection
  setAnalyticsCollectionEnabled(analytics, true);

  // Enable debug mode only in development
  if (process.env.NODE_ENV !== 'production') {
    window.ga_debug = { trace: true };
  }

  // Only do this in development!
  if (window.location.hostname === "localhost") {
    const functions = getFunctions();
    connectFunctionsEmulator(functions, "localhost", 5001); // 5001 is the default port
  }
}

// Function to log page views
export const logPageView = (pageData) => {
  if (analytics) {
    // Log only screen_view event
    logEvent(analytics, 'screen_view', {
      firebase_screen: pageData.screen_name,
      firebase_screen_class: pageData.page_title
    });
  }
};

export const logCustomEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

export { perf, analytics };
